import React from 'react';
import { getLevelIcon } from '../utils/buildingLevels';

/**
 * Level Badge Component
 * Displays the current level with icon and color
 */
const LevelBadge = ({ level }) => {
  if (!level) return null;

  const icon = getLevelIcon(level.name);

  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full ${level.bgColor} text-white font-bold !text-lg shadow-lg`}
    >
      <span className="!text-xl">{icon}</span>
      <span>{level.name}</span>
    </div>
  );
};

export default LevelBadge;
